import { request } from "../util/Request";

export async function getAllIntegrationModules() {
    const response = await request("/api/IntegrationModule/GetAll");
    console.log(response);
    return await response.json();
  }